import { AppThunk } from '../../../store/rootReducer';
import * as ecgListActions from '../actions/ecg-list.actions';
import {
  bufferedItemSelector,
  currentItemSelector,
} from '../selectors/ecg-list.selectors';
import { EcgItem } from '../types/ecg.type';
import { loadNextPage } from './load-next-page.thunk';

export const loadEcgList = (): AppThunk<Promise<EcgItem[] | null>> => async (
  dispatch,
  getState,
) => {
  const currentItem = currentItemSelector(getState());
  const bufferedItem = bufferedItemSelector(getState());

  if (currentItem == null) {
    // either we're loading for the first time or we've reached the end
    // of the list, and the back no longer has ECGs at the given page
    // we clear the list, to start over in case new ECGs were assigned
    dispatch(ecgListActions.reset({ meta: { history: false } }));
    return await dispatch(loadNextPage());
  }

  if (bufferedItem == null) {
    // we preload the next page in the background
    dispatch(loadNextPage());
  }
  return [currentItem];
};
